import lodashGet from "lodash/get";
import lodashForOwn from "lodash/forOwn";

export { _addSource as addSource };
export { _removeAllDataSources as removeAllDataSources };
export { _removeSource as removeSource };
export { _cleanUpSources as cleanUpSources };

let sources = {};

const _addSource = (map, sourceId, source) => {
  _handleAddSource(map, sourceId, source);
};

const _handleAddSource = (map, sourceId, source) => {
  if (map) {
    const IDENTIFIER = _getSourceIdentifier(map, sourceId);
    if (sources[IDENTIFIER] && map.getSource(sourceId)) {
      _updateSource(map, sourceId, source);
    } else {
      map.addSource(sourceId, source);
      sources[IDENTIFIER] = source;
    }
  }
};

const _updateSource = (map, sourceId, source) => {
  const IDENTIFIER = _getSourceIdentifier(map, sourceId);
  let mapSource = map.getSource(sourceId);
  if (typeof mapSource.setData === "function") {
    mapSource.setData(source.data);
  }
  sources[IDENTIFIER] = source;
};

const _getSourceIdentifier = (map, sourceId) => {
  if (lodashGet(map, "_container.id")) {
    return map._container.id + "-" + sourceId;
  }
  return null;
};

const _removeAllDataSources = (map, sourceId) => {
  _removeSource(map, sourceId);
  _removeSource(map, sourceId + "-heatmap");
  _removeSource(map, sourceId + "-geohash");
};

const _removeSource = (map, sourceId) => {
  _handleRemoveSource(map, sourceId);
  _cleanUpSources(map);
};

const _handleRemoveSource = (map, sourceId) => {
  const IDENTIFIER = _getSourceIdentifier(map, sourceId);
  if (sources[IDENTIFIER] && map.getSource(sourceId)) {
    map.removeSource(sourceId);
    delete sources[IDENTIFIER];
  }
};

const _cleanUpSources = (map) => {
  if (
    map &&
    map.getStyle() &&
    map.getStyle().sources &&
    map.getStyle().layers
  ) {
    const SOURCES = map.getStyle().sources;
    const LAYERS = map.getStyle().layers;
    if (SOURCES && LAYERS) {
      const LEN = LAYERS.length;
      let sourcesToRemove = [];
      lodashForOwn(SOURCES, (value, key) => {
        let exists = false;
        if (key && value) {
          for (let i = 0; i < LEN; i++) {
            const LAYER = LAYERS[i];
            if (LAYER.source === key) {
              exists = true;
            }
          }
          if (!exists) {
            sourcesToRemove.push(key);
          }
        }
      });
      if (sourcesToRemove.length) {
        sourcesToRemove.forEach((sourceId) => {
          _removeSource(map, sourceId);
        });
      }
    }
  }
};
